var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group" }, [
    _c(
      "div",
      { staticClass: "group-header" },
      [
        _vm.group.id
          ? _c("AgentAvatar", {
              key: _vm.group.id,
              attrs: { size: 50, "font-size": 15, userID: _vm.group.id },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("h2", [_vm._v(_vm._s(_vm.getAgentName(_vm.group.id)))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "group-stats" },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("star")]),
            _vm._v(" "),
            _c("div", { staticClass: "group-stats-item total" }, [
              _c("span", { staticClass: "key" }, [
                _vm._v(_vm._s(_vm.$t("chatWindow.totalCustomer"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.groupStats.totalCustomers)),
              ]),
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "material-icons" }, [_vm._v("star")]),
            _vm._v(" "),
            _c("div", { staticClass: "group-stats-item answered" }, [
              _c("span", { staticClass: "key" }, [
                _vm._v(" " + _vm._s(_vm.$t("chatWindow.answered"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.groupStats.answered)),
              ]),
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "material-icons" }, [_vm._v("star")]),
            _vm._v(" "),
            _c("div", { staticClass: "group-stats-item unanswered" }, [
              _c("span", { staticClass: "key" }, [
                _vm._v(_vm._s(_vm.$t("chatWindow.unanswered"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.groupStats.unanswered)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "SupsisButton",
              { attrs: { ghost: "" }, on: { click: _vm.handleWatchAll } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.watchAllLive")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "customers" },
      _vm._l(_vm.group.items, function (item) {
        return _c("CustomerCard", {
          key: item.name,
          attrs: {
            item: item,
            "group-id": _vm.group.id,
            "agent-name": _vm.getAgentName(_vm.group.id),
            "selected-item-id": _vm.selectedItemId,
          },
          on: { select: _vm.handleCustomerSelect },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }